import React from 'react'
import VotesListItemRenderer from '../VotesListItemRenderer'
import Icon, { IconType } from '../../Icon'
import style from './VotesList.module.scss'
import { VotesListProps, VotesMode, WebcastStatusForVotes } from './../types'
import EmptySidePanel from '../../EmptySidePanel'
import styles from '@bt-react/styles'
import Button, { ButtonType } from '../../Button'
import componentStyles from '../VotesView/VotesView.module.scss'
import classNames from 'classnames'

const BUTTON_TEXT = 'Add poll question'

const VotesList: React.FC<VotesListProps> = ({ votes, setMode, webcastStatus }) => {

  const addWebcastsEnabled = votes.length < 10 && webcastStatus === WebcastStatusForVotes.UPCOMING

  return <div
    className={ style['polls_questions_list'] }
    data-bdd='talks-polls-questions-list-container'>
    {
      votes && !!votes.length && <div
        className={ classNames([ style['bold'], style['polls_question_label'] ]) }
      >
        Polls added:
      </div>
    }
    { votes && votes.length ? votes.map((vote, i) => (
        <VotesListItemRenderer
          question={ vote.question }
          id={ vote.id }
          status={vote.status}
          setMode={ setMode }
          key={ vote.id ?? i }/>
      )) :
      <EmptySidePanel
        icon={IconType.iconName.votes}
        title={'No polls added'}
        text={'Poll questions must be added up until 5 minutes before scheduled start time'}
      />
    }
    { addWebcastsEnabled && <div className={ style['polls_add_poll_btn'] }>
      <Button
        dataBdd='add-poll-question-button'
        text={ BUTTON_TEXT }
        className={ componentStyles['button'] }
        type={ ButtonType.buttonType.button }
        onClick={ () => setMode({ mode: VotesMode.EDIT }) }
      >
        <Icon
          name={ IconType.iconName.plus }
          colour={ IconType.colour.white }
        />
      </Button>
    </div> }
  </div>
}

export default VotesList

